import { apiSlice } from "./apiSlice";



const categorizeSubs = (responseData: any) => {
    const mapped: any = {
        GENERAL: [],
        AIAN: []
    };

    responseData.forEach((subApp: any) => {

        switch (subApp.ducType) {
        case "GENERAL":
            mapped.GENERAL.push(subApp);
            break;
        case "AIAN":
            mapped.AIAN.push(subApp);
            break;
        }
    });

    return mapped;
};


export const ducApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        submitDUC: builder.mutation({
            query: data => ({
                url: '/duc',
                method: 'POST',
                body: { ...data }
            }),
            invalidatesTags: () => [{ type: "DUCInfo" }],
        }),

        getDUCInfo: builder.query({
            query: ({ email }) => `/duc/${email}`,
            providesTags: () => {
                return [{ type: "DUCInfo" }];
            },
        }),

        getDUCUrl: builder.query({
            query: ({ id }) => `/duc/url/${id}`,
            providesTags: () => {
                return [{ type: "DUCInfo" }];
            },
        }),

        getDUCFile: builder.query({
            query: ({ id }) => `/duc/file/${id}`,
            providesTags: () => {
                return [{ type: "DUCInfo" }];
            },
        }),
        getTrainingUrl: builder.query({
            query: ({ username }) => `/training/${username}`,
            providesTags: () => {
                return [{ type: "DUCInfo" }];
            },
        }),
        getDucInfoByID: builder.query({
            query: ({ id }) => `/duc/ducdetails/${id}`,
            providesTags: () => {
                return [{ type: "DUCInfo" }];
            },
        }),
        reSubmitDUC: builder.mutation({
            query: ({ data, id }) => ({
                url: `/duc/update/${id}`,
                method: 'PUT',
                body: { ...data }
            }),
            invalidatesTags: () => [{ type: "DUCInfo" }],
        }),

        checkSubApplicants: builder.mutation({
            query: (data) => ({
                url: `/duc/validate-subapplicants`,
                method: 'POST',
                body: { ...data }
            }),
            invalidatesTags: () => [{ type: "DUCInfo" }],
        }),

        deleteDUC: builder.mutation({
            query: ({ id }) => ({
                url: `/duc/cancel/${id}`,
                method: 'POST',
            }),
            invalidatesTags: () => [{ type: "DUCInfo" }],
        }),

        getSubApplicants: builder.query({
            query: ({ username }) => `/duc/${username}/subapplicants`,
            transformResponse: (responseData: any) => categorizeSubs(responseData),
            providesTags: ['DUCInfo'],
        }),

        revokeAccess: builder.mutation({
            query: ({ id }) => ({
                url: `/duc/subapplicants/revoke/${id}`,
                method: 'POST',
            }),
            invalidatesTags: ["DUCInfo"],
        }),

        addSubApplicant: builder.mutation({
            query: (data) => ({
                url: `/duc/add/subapplicants`,
                method: 'POST',
                body: { ...data }
            }),
            invalidatesTags: () => [{ type: "DUCInfo" }],
        }),

    })
});

export const {
    useSubmitDUCMutation,
    useGetDUCInfoQuery,
    useGetDUCUrlQuery,
    useGetDUCFileQuery,
    useGetTrainingUrlQuery,
    useGetDucInfoByIDQuery,
    useReSubmitDUCMutation,
    useCheckSubApplicantsMutation,
    useDeleteDUCMutation,
    useGetSubApplicantsQuery,
    useRevokeAccessMutation,
    useAddSubApplicantMutation
} = ducApiSlice;